module.exports = __webpack_public_path__ + "img/01-6.639e65b9.png";